import React from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import Info from "@material-ui/icons/Info";
import Tooltip from "@material-ui/core/Tooltip";
import classNames from "classnames";

const PositionChip = ({ children, classes, infoCircleClass }) => (
  <Tooltip
    title={children}
    classes={{ tooltip: classes.infoTooltip }}
    placement="top"
  >
    <Info className={classNames(classes.infoCircle, infoCircleClass)} />
  </Tooltip>
);

export default withStyles(styles, { withTheme: true })(PositionChip);
